import React, { FC } from 'react';
import './Footer.style.scss';
import images from '../../../../assets/images';

const Footer: FC<any> = (props) => {
  return (
    <footer className="footer-pagecontent">
      <div className="footer-pagecontentbody">
        <div className="follow-us">
          <div className="img-tiktiki">
            <img src={images.common.tik} alt="tiktiki img" />
          </div>
          <h4>Follow Us</h4>
          <a href="https://www.facebook.com/itagamabd">
            <img src={images.layout.socialiconFacebook} alt="Facebook" />
          </a>
          <a href="#">
            <img src={images.layout.socialiconTwitter} alt="twitter" />
          </a>
          <a href="https://www.youtube.com/channel/UCk_j_80SzjZYoPUfYAkB-Vw">
            <img src={images.layout.socialiconYoutube} alt="Youtube" />
          </a>
          <a href="https://www.linkedin.com/in/it-agama-275545202/">
            <img src={images.layout.socialiconLinkedine} alt="Linkedine" />
          </a>
          <a href="#">
            <img src={images.layout.socialiconInstagram} alt="Instagram" />
          </a>
        </div>
        <div className="copyright-textmessage">
          <p>
            Copyright @ 2021, Itagama.com or its affiliates. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
